import { Link } from "react-router-dom";
import { useSEO } from "@/lib/seo";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
    useSEO({
        title: "404 — Sidan hittades inte",
        description: "Sidan du söker finns inte längre eller har flyttats.",
    });

    return (
        <section
            data-testid="page-404"
            className="relative min-h-[85vh] grid place-items-center py-24 overflow-hidden"
        >
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[520px] h-[520px] bg-[#C4A977]/[0.06] rounded-full blur-3xl" />
            </div>
            <div className="relative max-w-2xl mx-auto px-4 text-center">
                <p className="font-serif text-[140px] lg:text-[200px] leading-none text-[#C4A977]/20 select-none">
                    404
                </p>
                <p className="overline">Sidan hittades inte</p>
                <h1 className="mt-4 font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
                    Här blev det{" "}
                    <span className="italic text-[#C4A977]">
                        ett missförstånd
                    </span>
                    .
                </h1>
                <p className="mt-6 text-[#A1A1AA] max-w-md mx-auto leading-relaxed">
                    Sidan du sökte finns inte längre eller har flyttats. Kanske
                    hittar du det du letar efter från startsidan.
                </p>
                <div className="mt-10 flex flex-wrap gap-3 justify-center">
                    <Link
                        to="/"
                        data-testid="404-home-link"
                        className="inline-flex items-center gap-2 px-6 py-3 bg-[#C4A977] text-black hover:bg-[#DBC08F] rounded-sm text-sm font-medium"
                    >
                        <ArrowLeft size={14} /> Till startsidan
                    </Link>
                    <Link
                        to="/kontakt"
                        className="inline-flex items-center gap-2 px-6 py-3 border border-white/15 hover:border-[#C4A977] hover:text-[#C4A977] rounded-sm text-sm"
                    >
                        Kontakta oss
                    </Link>
                </div>
            </div>
        </section>
    );
}
